import(/* webpackMode: "eager", webpackExports: ["GoBack"] */ "/var/www/joy-awards-frontend/src/app/[lang]/news/[id]/components/go-back.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/joy-awards-frontend/src/app/[lang]/news/[id]/components/news-html-content-client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Image"] */ "/var/www/joy-awards-frontend/src/components/shared/image/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/joy-awards-frontend/src/components/shared/link/index.tsx");
